import React from "react";
import { Link } from "react-router-dom";
import { Newspaper, Briefcase, Package, Mail, Activity, CheckCircle, Pause, Hourglass, Archive } from "lucide-react";
import PageShell from "../../components/layout/PageShell";
import PageHead from "../../components/layout/PageHead";
import { usePermissions } from "../../context/permissionContext";
import { validatePermission } from "../../utils/permissionUtils";
import "./staffHome.scss";

// Landing page for a staff seat that is not the platform administrator (for
// example a marketing EMPLOYEE). It makes NO request: the operations dashboard's
// figures are platform-wide and AD-only. Each card is a section the session's
// permissions open; the same strings gate the routes and the sidebar.
const SECTIONS = [
  { perm: "News:View", to: "/news", Icon: Newspaper, title: "News, Insights & Events", text: "Publish news, insights and events on the website." },
  { perm: "Careers:View", to: "/careers", Icon: Briefcase, title: "Careers", text: "Job posts and applicants." },
  { perm: "InventMe Management:View", to: "/inventme", Icon: Package, title: "InventMe", text: "Review and moderate submitted ideas." },
  { perm: "Marketing Campaigns:View", to: "/ad/marketing/campaigns", Icon: Mail, title: "Newsletters", text: "Write, test and send email campaigns." },
  { perm: "Campaign - Active:View", to: "/active-campaign", Icon: Activity, title: "Active deals", text: "Deals open for investment (read-only)." },
  { perm: "Campaign - Upcoming Campaigns:View", to: "/coming-soon-campaign", Icon: Hourglass, title: "Upcoming deals", text: "Deals announced but not yet open (read-only)." },
  { perm: "Campaign - Paused campaigns:View", to: "/paused-campaign", Icon: Pause, title: "Paused deals", text: "Read-only." },
  { perm: "Campaign - Completed:View", to: "/completed-campaign", Icon: CheckCircle, title: "Completed deals", text: "Read-only." },
  { perm: "Campaign - Closed Campaigns:View", to: "/closed-campaign", Icon: Archive, title: "Closed deals", text: "Read-only." },
];

const StaffHome = () => {
  const { permissions, permissionsMapping } = usePermissions();
  const open = SECTIONS.filter((section) => validatePermission(section.perm, permissions || [], permissionsMapping || {}));

  return (
    <PageShell>
      <PageHead title="Welcome" subtitle={<span>Your workspace</span>} />
      {open.length ? (
        <div className="staff-home__grid">
          {open.map(({ to, Icon, title, text }) => (
            <Link key={to} to={to} className="staff-home__card">
              <Icon aria-hidden="true" />
              <span className="staff-home__title">{title}</span>
              <span className="staff-home__text">{text}</span>
            </Link>
          ))}
        </div>
      ) : (
        <p className="staff-home__empty">
          Your account does not have access to any admin section yet. Please ask the platform manager to grant it.
        </p>
      )}
    </PageShell>
  );
};

export default StaffHome;
